module.exports = __webpack_public_path__ + "img/4c058958-dca9-4b81-9c59-2001020ec687.c4123027.png";